const canUseWindow = () => typeof window !== "undefined";

const getStorage = (type: "local" | "session"): Storage | null => {
  if (!canUseWindow()) return null;

  try {
    return type === "session" ? window.sessionStorage : window.localStorage;
  } catch {
    return null;
  }
};

export const getSessionStorageItem = (key: string): string | null => {
  const storage = getStorage("session");
  if (!storage) return null;

  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
};

export const setSessionStorageItem = (key: string, value: string): boolean => {
  const storage = getStorage("session");
  if (!storage) return false;

  try {
    storage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const removeSessionStorageItem = (key: string): boolean => {
  const storage = getStorage("session");
  if (!storage) return false;

  try {
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

export const getCookieValue = (name: string): string => {
  if (typeof document === "undefined") return "";

  try {
    const cookie = document.cookie
      .split(";")
      .map((part) => part.trim())
      .find((part) => part.startsWith(`${name}=`));

    if (!cookie) return "";

    const value = cookie.slice(name.length + 1);

    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  } catch {
    return "";
  }
};
